// removed by extract-text-webpack-plugin
module.exports = {"h3":"src-styles----capabilities-module---h3---2EbVs","h4":"src-styles----capabilities-module---h4---3TcW3","section":"src-styles----capabilities-module---section---181FC","images":"src-styles----capabilities-module---images---1Odfd"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/capabilities.module.scss
// module id = 806
// module chunks = 93803410282108